import * as React from "react";
const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 75 75"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1859 1.37247C35.0649 0.493679 36.257 0 37.5 0C38.743 0 39.9351 0.493679 40.8142 1.37247L73.6275 34.1858C74.2829 34.8414 74.7292 35.6766 74.91 36.5858C75.0908 37.4949 74.9979 38.4373 74.6432 39.2937C74.2885 40.1502 73.6878 40.8822 72.9172 41.3973C72.1465 41.9124 71.2404 42.1874 70.3134 42.1876H65.6258V70.3134C65.6258 71.5566 65.1319 72.7489 64.2528 73.628C63.3737 74.5071 62.1814 75.001 60.9381 75.001H51.5629C50.3196 75.001 49.1273 74.5071 48.2482 73.628C47.3691 72.7489 46.8753 71.5566 46.8753 70.3134V56.2505C46.8753 55.0073 46.3814 53.8149 45.5023 52.9358C44.6232 52.0567 43.4309 51.5629 42.1876 51.5629H32.8124C31.5691 51.5629 30.3768 52.0567 29.4977 52.9358C28.6186 53.8149 28.1248 55.0073 28.1248 56.2505V70.3134C28.1248 71.5566 27.6309 72.7489 26.7518 73.628C25.8727 74.5071 24.6804 75.001 23.4371 75.001H14.0619C12.8186 75.001 11.6263 74.5071 10.7472 73.628C9.86812 72.7489 9.37425 71.5566 9.37425 70.3134V42.1876H4.68663C3.75965 42.1874 2.85354 41.9124 2.08284 41.3973C1.31215 40.8822 0.711483 40.1502 0.35677 39.2937C0.00205764 38.4373 -0.0907715 37.4949 0.0900187 36.5858C0.270809 35.6766 0.717101 34.8414 1.37248 34.1858L34.1859 1.37247Z"
      fill={props.color ? props.color : "black"}
    />
  </svg>
);
export default HomeIcon;
